import { Component } from '@angular/core';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  constructor(public mobileMenu: MobileMenuService) { }

}
